export default __webpack_public_path__ + "static/images/exo-event2.png";